<template>
    <div>
        <div ref="flags" class="flags d-flex">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectCountryFlag',

    props: {
        old: Object
    },

    data(){
        return {
            selectedCountry: '',
            lastSelected: null
        }
    },

    mounted(){
        for(let child of this.$refs.flags.children){
            child.addEventListener('click', this.clicked);
        }

        if(this.old){
            this.selectedCountry = this.old.country;
            this.$emit('country_changed', this.old.country);
        }
    },

    methods: {
        clicked(event){
            if(this.lastSelected !== null){
                this.lastSelected.classList.remove('selected')
            }
            this.selectedCountry = event.srcElement.__vue__.$options.propsData.country;
            this.lastSelected = event.srcElement;
            event.srcElement.classList.add('selected')
            this.$emit('country_changed', this.selectedCountry);
        }
    }
}
</script>

<style>
.big-flag {
    outline: 3px solid #ced4da;
    transform: scale(0.84) !important;
    margin-right: 6px !important;
    border-radius: 0.42rem;
    opacity: 0.5;
    transition: .16s;
}
.big-flag:hover {
    opacity: 1.0;
}
.selected {
    outline-color: #9881F6;
    opacity: 1.0;
}
</style>
